import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESERVAR_POUPANCA, SUPERAVITE } from '../../../../app.constants';
import { OcorrenciaReservaPoupancaModel } from '../../../shared/models/ocorrencia-reserva-poupanca.model';
import { ReservaPoupancaModel } from '../../../shared/models/reserva-poupanca.model';
import { SuperavitModel } from '../../../shared/models/superavit.model';


@Injectable()
export class PbdcService {


  constructor(private httpClient: HttpClient) { }



  // SUPERAVIT REST ENDPOINT
  getVerificarPatronal(cdCentrus: number, cdCentrusTit: number, tpExtrato, nrSuperavit): Promise<boolean> {
    return this.httpClient
      .get<boolean>(`${SUPERAVITE}/verificarPatronal/${cdCentrus}/${cdCentrusTit}/${tpExtrato}/${nrSuperavit}`)
      .toPromise();
  }

  getBuscaValorDestinacao(cdCentrus: number, nrSuperavit): Promise<number> {
    return this.httpClient
      .get<number>(`${SUPERAVITE}/buscaValorDestinacao/${cdCentrus}/${nrSuperavit}`)
      .toPromise();
  }


  getConsultaSuperavitCentrus(cdCentrus: number, cdCentrusTit: number, tpExtrato, nrSuperavit): Promise<SuperavitModel[]> {
    return this.httpClient
      .get<SuperavitModel[]>(`${SUPERAVITE}/consultaSuperavitCentrus/${cdCentrus}/${cdCentrusTit}/${tpExtrato}/${nrSuperavit}`)
      .toPromise();
  }

  getPageConsultaSuperavitCentrus(cdCentrus: number, cdCentrusTit: number, tpExtrato, nrSuperavit, linesPerPage: number, page: number): Promise<SuperavitModel[]> {
    return this.httpClient
      .get<SuperavitModel[]>(`${SUPERAVITE}/page/consultaSuperavitCentrus/${cdCentrus}/${cdCentrusTit}/${tpExtrato}/${nrSuperavit}?linesPerPage=${linesPerPage}&page=${page}`)
      .toPromise();
  }

  // RESERVA DE POUPANÇA REST ENDPOINT
  getVerificarDtBeneficio(cdCentrus: number): Promise<number> {
    return this.httpClient
      .get<number>(`${RESERVAR_POUPANCA}/verificarDtBeneficio/${cdCentrus}`)
      .toPromise();
  }

  getConsultaReservaPoupanca(cdCentrus: number): Promise<ReservaPoupancaModel> {
    return this.httpClient
      .get<ReservaPoupancaModel>(`${RESERVAR_POUPANCA}/consultaReservaPoupanca/${cdCentrus}`)
      .toPromise();
  }

  getConsultaOcorrenciasReservaPoupanca(cdCentrus: number): Promise<OcorrenciaReservaPoupancaModel[]> {
    return this.httpClient
      .get<OcorrenciaReservaPoupancaModel[]>(`${RESERVAR_POUPANCA}/ocorrenciaReservaPoupanca/${cdCentrus}`)
      .toPromise();
  }

  getPageConsultaOcorrenciasReservaPoupanca(cdCentrus: number, linesPerPage: number, page: number): Promise<OcorrenciaReservaPoupancaModel[]> {
    return this.httpClient
      .get<OcorrenciaReservaPoupancaModel[]>(`${RESERVAR_POUPANCA}/page/ocorrenciaReservaPoupanca/${cdCentrus}?linesPerPage=${linesPerPage}&page=${page}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/service/pbdc.service.ts